import { useCarousel } from '@hooks/useCarousel';
import noop from 'lodash/noop';
import * as React from 'react';
export const CarouselContext = React.createContext({
    activeIndex: 0,
    goToIndex: noop,
    goToNext: noop,
    goToPrev: noop,
    reinitialise: noop,
    maxIndex: 0,
    offset: 0,
    offsets: [],
    recalculate: noop,
    refContainer: null,
    refTrack: null,
    count: 0,
    showNavigation: false,
});
export const useCarouselContext = () => React.useContext(CarouselContext);
const CarouselProvider = ({ children, ...otherProps }) => {
    const carousel = useCarousel(otherProps);
    return React.createElement(CarouselContext.Provider, { value: carousel }, children);
};
export default CarouselProvider;
